module.exports = __webpack_public_path__ + "static/media/reduced.04db9ba3.png";